var map = {
	"./angular.png": 2187,
	"./argocd.png": 4710,
	"./aws.png": 6603,
	"./azure.png": 2874,
	"./bootstrap.png": 2267,
	"./canary.png": 427,
	"./cf.png": 4782,
	"./clojure.png": 8350,
	"./cpp.png": 7688,
	"./css.png": 5988,
	"./deno.png": 7294,
	"./docker.png": 3994,
	"./flutter.png": 9076,
	"./gcp.png": 6666,
	"./go.png": 631,
	"./graphql.png": 1382,
	"./grpc.png": 9267,
	"./hasura.png": 3109,
	"./helm.png": 1298,
	"./html.png": 2789,
	"./java.png": 7179,
	"./js.png": 130,
	"./k8s.png": 7043,
	"./logo.png": 6949,
	"./mongo.png": 5997,
	"./mysql.png": 4510,
	"./nextjs.png": 6477,
	"./nodejs.png": 8385,
	"./openai.png": 6373,
	"./parrot-icon.png": 5668,
	"./parrot-left.png": 3874,
	"./parrot-right.png": 4757,
	"./php.png": 7621,
	"./postgres.png": 6497,
	"./python.png": 4758,
	"./react.png": 4037,
	"./ruby.png": 6556,
	"./scala.png": 9010,
	"./swift.png": 1092,
	"./tf.png": 4507,
	"./ts.png": 8140,
	"./vim.png": 4329,
	"./vuejs.png": 4178,
	"./wordpress.png": 2617,
	"./x.png": 8162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;